export const APIURL = { 

    _sendSms:"vc-portal/sms/send",
_getPatientDetails:"vc-portal/patient/",
_cancelVisit:"vc-portal/cancel/",
_getVisitVCStart:"vc-portal/start/",
_getVisitLocation:"vc-portal/patient/location/",
_getVisitComplete:"vc-portal/complete/"
    
}